import { LegacyCard } from '@shopify/polaris';
import { useContext } from 'react';
import { useState } from 'react';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import { getProducts } from '../../../services/productService';
import { getSellsStockById, postSellsStockById } from '../../../services/sellsService';
import ProductCard from '../Products/ProductCard';
import ProductFindCard from '../Products/ProductFindCard';
import SellAddStockTable from '../Tables/SellAddStockTable';

const AddStockCard = ({ sell, onStockAdded }) => {
  const [productFound, setProductFound] = useState(null);
  const [productListFound, setProductListFound] = useState([]);
  const [stockToAdd, setStockToAdd] = useState([]);
  const [, dispatchToast] = useContext(ToastContext);

  const handleSearch = (family) =>
    getProducts({ s: family, empty: true }).then((r) => {
      if (r.data.data.length === 1) {
        setProductFound(r.data.data[0]);
        setProductListFound([]);
      } else {
        setProductFound(null);
        setProductListFound(r.data.data.map(({ family }) => family));
      }
    });

  const handleClearSearch = () => {
    setProductFound(null);
    setProductListFound([]);
  };

  const handleStockToAddChange = (qtys) => {
    setStockToAdd(qtys);
  };

  const handleAddQty = () =>
    postSellsStockById(sell.id, stockToAdd)
      .then((r) => {
        getSellsStockById(sell.id, { s: productFound.family }).then((rr) => onStockAdded(rr.data.data[0]));
        setProductFound(null);
        setProductListFound([]);
        setStockToAdd([]);
        dispatchToast({ type: SET_OK, payload: r.data });
      })
      .catch((e) => {
        dispatchToast({ type: SET_ERROR, payload: e.response.data });
      });

  return (
    <LegacyCard
      title="Añadir stock"
      primaryFooterAction={
        productFound && { content: 'Añadir stock', disabled: !stockToAdd.length, onAction: handleAddQty }
      }
      secondaryFooterActions={
        productFound && [{ content: 'Limpiar', onAction: handleClearSearch, destructive: true, plain: true }]
      }>
      <LegacyCard.Section>
        <ProductFindCard
          onSearch={handleSearch}
          onClearSearch={handleClearSearch}
          product={productFound}
          optionList={productListFound}
        >
          {productFound && (
            <ProductCard product={productFound} wide={true}>
              <SellAddStockTable product={productFound} sell={sell} onAddQty={handleStockToAddChange} />
            </ProductCard>
          )}
        </ProductFindCard>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default AddStockCard;
